export const bloodTypeOptions = [
  { label: "A+", value: "A+" },
  { label: "A-", value: "A-" },
  { label: "B+", value: "B+" },
  { label: "B-", value: "B-" },
  { label: "AB+", value: "AB+" },
  { label: "AB-", value: "AB-" },
  { label: "O+", value: "O+" },
  { label: "O-", value: "O-" },
];

export const userTypeOptions = [
  { label: "Internal", value: "internal" },
  { label: "External", value: "external" },
];

export const doctorSpecializationOptions = [
  { label: "Allergist / Immunologist", value: "Allergist / Immunologist" },
  { label: "Cardiologist", value: "Cardiologist" },
  { label: "Dermatologist", value: "Dermatologist" },
  { label: "Endocrinologist", value: "Endocrinologist" },
  {
    label: "ENT Specialist (Otolaryngologist)",
    value: "ENT Specialist (Otolaryngologist)",
  },
  { label: "Gastroenterologist", value: "Gastroenterologist" },
  { label: "General Practitioner", value: "General Practitioner" },
  { label: "General Surgeon", value: "General Surgeon" },
  { label: "Hematologist", value: "Hematologist" },
  { label: "Nephrologist", value: "Nephrologist" },
  { label: "Neurologist", value: "Neurologist" },
  {
    label: "Obstetrician-Gynecologist (OB-GYN)",
    value: "Obstetrician-Gynecologist (OB-GYN)",
  },
  { label: "Oncologist", value: "Oncologist" },
  { label: "Ophthalmologist", value: "Ophthalmologist" },
  { label: "Orthopedic Surgeon", value: "Orthopedic Surgeon" },
  { label: "Pediatrician", value: "Pediatrician" },
  { label: "Psychiatrist", value: "Psychiatrist" },
  { label: "Pulmonologist", value: "Pulmonologist" },
  { label: "Rheumatologist", value: "Rheumatologist" },
];

export const doctorSpecializationOptionsArr = [
  "Allergist / Immunologist",
  "Cardiologist",
  "Dermatologist",
  "Endocrinologist",
  "ENT Specialist (Otolaryngologist)",
  "Gastroenterologist",
  "General Practitioner",
  "General Surgeon",
  "Hematologist",
  "Nephrologist",
  "Neurologist",
  "Obstetrician-Gynecologist (OB-GYN)",
  "Oncologist",
  "Ophthalmologist",
  "Orthopedic Surgeon",
  "Pediatrician",
  "Psychiatrist",
  "Pulmonologist",
  "Rheumatologist",
];

export const qualificationOptions = [
  "MD – Doctor of Medicine",
  "DO – Doctor of Osteopathic Medicine",
  "MBBS – Bachelor of Medicine, Bachelor of Surgery",
  "BMBS – Bachelor of Medicine, Bachelor of Surgery",
  "BMed – Bachelor of Medicine",
  "MS – Master of Surgery",
  "MCh – Master of Chirurgiae (super-specialization in surgery)",
  "PhD – Doctor of Philosophy (medical/health research)",
  "DNB – Diplomate of National Board",
  "FRCS – Fellow of the Royal College of Surgeons",
  "FRCP – Fellow of the Royal College of Physicians",
  "MPH – Master of Public Health",
  "MSc – Master of Science (medical/health sciences)",
  "DM – Doctorate of Medicine (super-specialized, e.g. Cardiology)",
  "DDS – Doctor of Dental Surgery",
  "DMD – Doctor of Dental Medicine",
  "RN – Registered Nurse",
  "RMT – Registered Medical Technologist",
  "PTRP – Licensed Physical Therapist",
  "RPh – Registered Pharmacist",
  "Midwife – Licensed Midwifery Qualification",
  "FPOGS – Fellow, Philippine Obstetrical and Gynecological Society",
  "MBA (Healthcare) – Master of Business Administration in Healthcare",
  "Diploma – Specialized medical training (e.g., Pediatrics, Dermatology)",
];

export const doctorCertificationOptionsPH = [
  "Certificate of Registration (PRC License)",
  "Fellow / Diplomate – Philippine College of Physicians (Internal Medicine)",
  "Fellow / Diplomate – Philippine Pediatric Society",
  "Fellow / Diplomate – Philippine Obstetrical & Gynecological Society",
  "Board Certification – Surgery Philippines",
  "LTO-Accredited Physician Registration",
  "Continuing Professional Development (CPD) Units – PRC",
  "Residency Graduation Certificate – Specialty Hospital",
  "Subspecialty / Fellowship Certificate",
  "Specialty Board Examination Passing Certificate",
  "Certificate of Membership - Philippine Medical Association (PMA)",
  "Certificate in Basic Life Support (BLS) – PH Accredited",
  "Certificate in Advanced Cardiac Life Support (ACLS) – PH Accredited",
  "Certificate in Pediatric Advanced Life Support (PALS) – PH Accredited",
  "Certificate in Ultrasound Training – PH Accredited",
];

export const inventoyCategoryOptions = [
  { label: "Medicine", value: "Medicine" },
  { label: "Supply", value: "Supply" },
  { label: "Equipment", value: "Equipment" },
  { label: "Vaccine", value: "Vaccine" },
  { label: "Others", value: "Others" },
];

export const inventoyTypeOptions = [
  { label: "Stock in", value: "Stock in" },
  { label: "Stock out", value: "Stock out" },
  // { label: "Adjustment", value: "Adjustment" },
];

export const inventoryUnitOptions = [
  { label: "Pieces (pcs)", value: "Pieces (pcs)" },
  { label: "Box", value: "Box" },
  { label: "Bottle", value: "Bottle" },
  { label: "Ampoule", value: "Ampoule" },
  { label: "Vial", value: "Vial" },
  { label: "Tablet", value: "Tablet" },
  { label: "Capsule", value: "Capsule" },
  { label: "Strip", value: "Strip" },
  { label: "Syringe", value: "Syringe" },
  { label: "Milliliters (ml)", value: "Milliliters (ml)" },
  { label: "Liters (l)", value: "Liters (l)" },
  { label: "Grams (g)", value: "Grams (g)" },
  { label: "Kilograms (kg)", value: "Kilograms (kg)" },
  { label: "Pack", value: "Pack" },
  { label: "Tube", value: "Tube" },
  { label: "Canister", value: "Canister" },
  { label: "Roll", value: "Roll" },
  { label: "Tray", value: "Tray" },
  { label: "Unit", value: "Unit" },
];
